import { ProbabilityDistributionType } from 'helicon';

export const PROBABILITY_DISTRIBUTION_TYPE_LABELS: {
  [type in ProbabilityDistributionType]: string;
} = {
  [ProbabilityDistributionType.Uniform]: 'uniform',
  [ProbabilityDistributionType.Exponential]: 'exponential',
  [ProbabilityDistributionType.Gaussian]: 'gaussian',
};
